import React from 'react';
import CorreosTabla from './CorreosTabla';

export default function CorreosPage() {
  return <CorreosTabla titulo="Correos enviados" />;
}
